<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data Production Control Time Detail">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="productionStandarTimes" optionsLabel="standarTimeName" optionsKey="id" label-cols-lg="12" label="Standar Time Name" id="input-" size="sm" :model.sync="model.standarTimeIdId" :isRequired="true" :state="validateState('standarTimeIdId')" :errorMessage="getErrorMessage(errorMessage.standarTimeIdId, 'standarTimeIdId')"   :selected="model.standarTimeId != null ? model.standarTimeId.standarTimeName : ''" @input="getProductionStandarTimes" />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-standar-time-value" label-cols-lg="12" label="Standar Time (Minutes)" label-for="input-standar-time-value" size="sm" :model.sync="model.standarTimeValue" :isRequired="true" :state="validateState('standarTimeValue')" :errorMessage="getErrorMessage(errorMessage.standarTimeValue, 'standarTimeValue')"  />
					</b-col>
					<b-col cols="12" lg="6">

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ProductionControlTimeDetail from '@/models/ProductionControlTime/ProductionControlTimeDetail';
import ProductionControlTimeDetailFilter from '@/filters/ProductionControlTime/ProductionControlTimeDetailFilter';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ProductionStandarTime from '@/models/ProductionStandarTime/ProductionStandarTime';
import ProductionStandarTimeFilter from '@/filters/ProductionStandarTime/ProductionStandarTimeFilter';
import ProductionControlTime from '@/models/ProductionControlTime/ProductionControlTime';
import ProductionControlTimeFilter from '@/filters/ProductionControlTime/ProductionControlTimeFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppLabel from '@/components/AppLabel';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppLabel,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		standarTimeIdId: {required},
			standarTimeValue: {required},
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
				standarTimeIdId: { required : "Standar Time Name is Required."},
				standarTimeValue: { required : "Standar Time (Minutes) is Required."},
			},
			productionStandarTimes : [],
			isBusy: false,
		}
	},
	methods : {
		getProductionControlTimeDetail : async function(id) {
			this.isBusy = true;
			ProductionControlTimeDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getProductionStandarTimes : async function(input) {
			let filter = new ProductionStandarTimeFilter();
			if (input != undefined) {
				filter.standarTimeName = input;
			}
			ProductionStandarTime.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.productionStandarTimes = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getProductionStandarTimes();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getProductionControlTimeDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getProductionStandarTimes();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getProductionControlTimeDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
